module.exports = __webpack_public_path__ + "img/firma-3.7d25c019.png";